export default "__VITE_ASSET__DZBUwYQl__"